import { ObjectMode } from '@databases/types';
import { Database } from '@databases/types/database';
import { DEFAULT_DATABASE_VIEW_SETTINGS } from '@databases/types/database/view';
import { getNewDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants';

// generate five random uuids
export const viewIds = [
  'e427bf37-b92b-403d-91bf-71224e9cb4f0',
  '08c16f24-3d8b-4217-885d-fd12adb0fa54',
  'df283abc-c7c0-400e-9e48-f2e688963404',
  '1a0e4fc1-7367-4dd3-9773-ae27a71a4190',
  '5f5afa8a-5411-4eab-b8ba-bd3688dfb9a4',
];

export const getDatabaseWithViews = (): Database<ObjectMode.EXISTING> => {
  const baseDatabase = getNewDatabase();

  const View4SettingsFields: { [fieldId: string]: boolean } = {};
  Object.values(baseDatabase.fieldsById).forEach((field) => {
    View4SettingsFields[field.id] = field.name !== 'User field';
  });

  const View4Settings = {
    ...DEFAULT_DATABASE_VIEW_SETTINGS,
    fields: { ...View4SettingsFields, default: false },
  };

  return {
    ...baseDatabase,
    views: [
      ...baseDatabase.views,
      ...viewIds.map((id, index) => ({
        id,
        name: `View ${index + 2}`,
        settings: index === 2 ? View4Settings : DEFAULT_DATABASE_VIEW_SETTINGS,
      })),
    ],
    contentId: databasesToContentId['databaseWithViews'],
    meta: {
      ...baseDatabase.meta,
      isLocked: false,
    },
    space: { key: 'TEST', name: 'Test', id: 1234 },
    operations: {
      delete: false,
      updateEntries: true,
      updateMetadata: true,
    },
  } as Database<ObjectMode.EXISTING>;
};
